var map = {
	"./en-asset-detail.jpg": 6308,
	"./en-asset-new.jpg": 9009,
	"./en-assets.jpg": 8381,
	"./en-borrow-dialog.jpg": 4352,
	"./en-byod-detail.jpg": 8396,
	"./en-byod-sign.jpg": 8959,
	"./en-compliance.jpg": 2851,
	"./en-dashboard-phone.jpg": 431,
	"./en-dashboard-tablet.jpg": 6091,
	"./en-dashboard.jpg": 712,
	"./en-faults.jpg": 6909,
	"./en-loan-detail.jpg": 232,
	"./en-loans-borrow.jpg": 4623,
	"./en-my-assets.jpg": 3976,
	"./en-policy.jpg": 9008,
	"./en-scan.jpg": 1637,
	"./en-schedule.jpg": 2877,
	"./en-users.jpg": 1188,
	"./id-asset-detail.jpg": 2058,
	"./id-asset-new.jpg": 843,
	"./id-assets.jpg": 4591,
	"./id-borrow-dialog.jpg": 1002,
	"./id-byod-detail.jpg": 6998,
	"./id-byod-sign.jpg": 3994,
	"./id-compliance.jpg": 9745,
	"./id-dashboard-phone.jpg": 1945,
	"./id-dashboard-tablet.jpg": 3285,
	"./id-dashboard.jpg": 4434,
	"./id-faults.jpg": 8195,
	"./id-loan-detail.jpg": 5034,
	"./id-loans-borrow.jpg": 9705,
	"./id-my-assets.jpg": 6502,
	"./id-policy.jpg": 4110,
	"./id-scan.jpg": 2399,
	"./id-schedule.jpg": 4635,
	"./id-users.jpg": 2938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3187;